import script from "./Payments.vue?vue&type=script&setup=true&lang=js"
export * from "./Payments.vue?vue&type=script&setup=true&lang=js"

import "./Payments.vue?vue&type=style&index=0&id=075a846a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075a846a"]])

export default __exports__